import _flatMap from 'lodash-es/flatMap';

export const bootstrapResponsiveBreakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};
type PlainColor =
  | 'red'
  | 'orange'
  | 'amber'
  | 'yellow'
  | 'lime'
  | 'green'
  | 'teal'
  | 'blue'
  | 'cobalt'
  | 'indigo'
  | 'purple'
  | 'pink'
  | 'rose';

export const allPlainColors: PlainColor[] = [
  'red',
  'orange',
  'amber',
  'yellow',
  'lime',
  'green',
  'teal',
  'blue',
  'cobalt',
  'indigo',
  'purple',
  'pink',
  'rose',
];

export const colorsValue = ['900', '700', '500', '400', '300', '200'] as const;

export const allGrayColorsAvailable = colorsValue.map(i => `gray-${i}`);

export const allColorsAvailable = [
  ...['black', 'white', ...allGrayColorsAvailable],
  ..._flatMap(allPlainColors.map(c => colorsValue.map(i => `${c}-${i}`))),
];

export const CURRENCIES = {
  EUR: {
    label: 'Euro',
    symbol: '€',
  },
  GBP: {
    label: 'British Pound',
    symbol: '£',
  },
  USD: {
    label: 'US Dollar',
    symbol: '$',
  },
  AUD: {
    label: 'AUS Dollar',
    symbol: 'A$',
  },
  XOF: {
    label: 'West African CFA Franc',
    symbol: 'CFA',
  },
  XPF: {
    label: 'CFP Franc',
    symbol: 'CFP',
  },
} as const;
